(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["te-shipping-progress"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('te-shipping-progress')) {
  customElements.define('te-shipping-progress', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const refresh = () => this.updateFromCart();
      document.addEventListener('cart:update', refresh, {signal:this.controller.signal});
      document.addEventListener('discount:update', refresh, {signal:this.controller.signal});
      this.updateFromCart();
    }
    disconnectedCallback() { this.controller?.abort(); }
    async updateFromCart() {
      const request = this.request = (this.request || 0) + 1;
      try {
        const response = await fetch(this.dataset.cartUrl, {signal:this.controller.signal});
        if (!response.ok) return;
        const cart = await response.json();
        if (request !== this.request || !this.isConnected || cart.currency !== this.dataset.currency) return;
        const threshold = Number(this.dataset.threshold);
        const remaining = Math.max(0, threshold - cart.total_price);
        const money = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:cart.currency,currencyDisplay:'code'}).format(remaining / 100);
        this.querySelector('[data-message]').textContent = remaining > 0 ? this.dataset.remaining.replace('__AMOUNT__',money) : this.dataset.unlocked;
        this.querySelector('progress').value = Math.min(100,Math.max(0,cart.total_price / threshold * 100));
      } catch {}
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
